import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./service-collaboration.actions";
import * as fromGraphql from "./service-collaboration.graphql";


@Injectable()
export class ServiceCollaborationEffects {
  create = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceCollaborationMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_COLLABORATION,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(
                fromActions.upsertServiceCollaboration({ serviceCollaboration: result?.data })
              );
              this.notificationService.successMessage(result?.response?.message).then();
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code).then();
            }
          }
        })
      );
    })
  ), { dispatch: false });

  update = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateServiceCollaborationMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_COLLABORATION,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertServiceCollaboration({ serviceCollaboration: result?.data })
              );
              this.notificationService.successMessage(result?.response?.message).then();
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code).then();
            }
          }
        })
      );
    })
  ), { dispatch: false });

  get = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllServiceCollaborations),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_SERVICE_COLLABORATIONS,
        variables: {
          serviceUniqueId: action?.serviceUniqueId
        },
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching serviceCollaborations'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceCollaborations({ serviceCollaborations: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  remove = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceCollaboration),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_COLLABORATION_REASON,
        variables: {
          uniqueId: action?.uniqueId
        },
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching serviceCollaborations'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            if (result?.response?.status) {
              this.store.dispatch(fromActions.deleteServiceCollaboration({ id: action?.id }))
              this.notificationService.successMessage(result?.response?.message).then();
            } else {
              this.notificationService.errorMessage(result?.response?.message).then();
            }
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
